import { RibbonGroupBase } from '../ribbon-interfaces';
import { RibbonItemSize } from '@syncfusion/ej2-ribbon';
import { BulletsGroup, BULLET_LIST_ID } from './bullets-group';
import { NumberingGroup, NUMBER_LIST_ID } from './numbering-group';
import { LineSpacingGroup, LINE_SPACING_ID } from './line-spacing-group';
import { BulletListHelper } from '../../helper/bullet-list-helper';
import { getInstance } from '@syncfusion/ej2-base';
import { SplitButton } from '@syncfusion/ej2-splitbuttons';
// Paragraph group constants
export const PARAGRAPH_GROUP_ID = '_paragraph_group';
export const ALIGN_LEFT_ID = '_align_left';
export const ALIGN_CENTER_ID = '_align_center';
export const ALIGN_RIGHT_ID = '_align_right';
export const JUSTIFY_ID = '_justify';
export const DECREASE_INDENT_ID = '_decrease_indent';
export const INCREASE_INDENT_ID = '_increase_indent';
export const SHOW_HIDE_MARKS_ID = '_show_hide_marks';
export const BORDERS_ID = '_borders';
/**
 * HomeParagraphGroup class for handling paragraph formatting operations in Document Editor ribbon
 * @private
 */
export class HomeParagraphGroup extends RibbonGroupBase {
    /**
     * Constructor for HomeParagraphGroup
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        super(container);
        // Initialize child components
        this.bulletsGroup = new BulletsGroup(container);
        this.numberingGroup = new NumberingGroup(container);
        this.lineSpacingGroup = new LineSpacingGroup(container);
    }
    /**
     * Get the Ribbon group model for Paragraph formatting
     * @returns {RibbonGroupModel} - Ribbon group model for Paragraph formatting
     * @private
     */
    getGroupModel() {
        const id = this.ribbonId;
        return {
            id: id + PARAGRAPH_GROUP_ID,
            cssClass: 'e-paragraph-group',
            header: this.localObj.getConstant('Paragraph'),
            isCollapsible: false,
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('More Paragraph Options'),
            groupIconCss: 'e-icons e-de-paragraph',
            orientation: 'Row',
            showLauncherIcon: true,
            launcherIconKeyTip: 'PG',
            collections: [{
                    id: id + '_paragraph-bullets',
                    items: [
                        this.bulletsGroup.getBulletListItem(),
                        this.numberingGroup.getNumberingListItem(),
                        {
                            type: 'Button',
                            keyTip: 'AO',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Increase indent'),
                                iconCss: 'e-icons e-de-ctnr-increaseindent',
                                clicked: () => {
                                    this.increaseIndentAction();
                                }
                            },
                            id: id + INCREASE_INDENT_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Increase indent') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'AI',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Decrease indent'),
                                iconCss: 'e-icons e-de-ctnr-decreaseindent',
                                clicked: () => {
                                    this.decreaseIndentAction();
                                }
                            },
                            id: id + DECREASE_INDENT_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Decrease indent') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'FM',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Show/Hide Marks'),
                                iconCss: 'e-icons e-de-e-paragraph-mark',
                                isToggle: true,
                                clicked: () => {
                                    this.toggleHiddenMarks();
                                }
                            },
                            id: id + SHOW_HIDE_MARKS_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('ShowHiddenMarks Tooltip') }
                        }
                    ]
                },
                {
                    items: [{
                            // type: RibbonItemType.GroupButton,
                            // allowedSizes: RibbonItemSize.Small,
                            // groupButtonSettings: {
                            //     selection: RibbonGroupButtonSelection.Single,
                            //     header: 'Alignment',
                            // items: [{
                            type: 'Button',
                            keyTip: 'AL',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Align left Tooltip'),
                                iconCss: 'e-icons e-de-ctnr-alignleft',
                                isToggle: true,
                                clicked: () => {
                                    this.leftAlignmentAction();
                                }
                            },
                            id: id + ALIGN_LEFT_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Align left Tooltip') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'AC',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Center Tooltip'),
                                iconCss: 'e-icons e-de-ctnr-aligncenter',
                                isToggle: true,
                                clicked: () => {
                                    this.centerAlignmentAction();
                                }
                            },
                            id: id + ALIGN_CENTER_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Center Tooltip') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'AR',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Align right Tooltip'),
                                iconCss: 'e-icons e-de-ctnr-alignright',
                                isToggle: true,
                                clicked: () => {
                                    this.rightAlignmentAction();
                                }
                            },
                            id: id + ALIGN_RIGHT_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Align right Tooltip') }
                        },
                        {
                            type: 'Button',
                            keyTip: 'AJ',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Justify Tooltip'),
                                iconCss: 'e-icons e-de-ctnr-justify',
                                isToggle: true,
                                clicked: () => {
                                    this.justifyAction();
                                }
                            },
                            id: id + JUSTIFY_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Justify Tooltip') }
                            // }]
                            // }
                        },
                        this.lineSpacingGroup.getLineSpacingItem(),
                        {
                            type: 'Button',
                            keyTip: 'B',
                            allowedSizes: RibbonItemSize.Small,
                            buttonSettings: {
                                content: this.localObj.getConstant('Borders'),
                                iconCss: 'e-icons e-de-ctnr-borders',
                                clicked: () => {
                                    this.bordersAction();
                                }
                            },
                            id: id + BORDERS_ID,
                            ribbonTooltipSettings: { content: this.localObj.getConstant('Borders') }
                        }
                    ]
                }]
        };
    }
    /**
     * Update paragraph formatting buttons based on document state
     * @returns {void} - void
     * @private
     */
    updateSelection() {
        // Get the ribbon from container
        const ribbon = this.container.ribbonModule.ribbon;
        if (!ribbon) {
            return;
        }
        const id = this.ribbonId;
        // Update toggle button states based on current selection
        if (this.documentEditor.selection) {
            const paragraphFormat = this.documentEditor.selection.paragraphFormat;
            // Update text alignment buttons
            this.updateToggleButtonState(id + ALIGN_LEFT_ID, paragraphFormat.textAlignment === 'Left');
            this.updateToggleButtonState(id + ALIGN_CENTER_ID, paragraphFormat.textAlignment === 'Center');
            this.updateToggleButtonState(id + ALIGN_RIGHT_ID, paragraphFormat.textAlignment === 'Right');
            this.updateToggleButtonState(id + JUSTIFY_ID, paragraphFormat.textAlignment === 'Justify');
            // Update show hidden marks button
            this.updateToggleButtonState(id + SHOW_HIDE_MARKS_ID, this.container.documentEditor.documentEditorSettings.showHiddenMarks);
            // Update line spacing
            this.lineSpacingGroup.setLineSpacing();
            // Update bullets/numbering toggle state based on current selection
            let isBulletActive = false;
            let isNumberActive = false;
            const hasList = !(paragraphFormat.listId === undefined || paragraphFormat.listId === -1);
            if (hasList) {
                const pattern = BulletListHelper.getCurrentListPattern(this.documentEditor);
                if (pattern === 'Bullet') {
                    isBulletActive = true;
                }
                else if (pattern && pattern !== 'None') {
                    isNumberActive = true;
                }
            }
            this.updateSplitButtonState(id + BULLET_LIST_ID, isBulletActive);
            this.updateSplitButtonState(id + NUMBER_LIST_ID, isNumberActive);
            // Disable buttons in read-only mode
            if (this.documentEditor.isReadOnly) {
                ribbon.disableItem(id + INCREASE_INDENT_ID);
                ribbon.disableItem(id + DECREASE_INDENT_ID);
                ribbon.disableItem(id + BULLET_LIST_ID);
                ribbon.disableItem(id + NUMBER_LIST_ID);
                ribbon.disableItem(id + BORDERS_ID);
                ribbon.disableItem(id + LINE_SPACING_ID);
            }
            else {
                ribbon.enableItem(id + INCREASE_INDENT_ID);
                ribbon.enableItem(id + BULLET_LIST_ID);
                ribbon.enableItem(id + NUMBER_LIST_ID);
                ribbon.enableItem(id + BORDERS_ID);
                ribbon.enableItem(id + LINE_SPACING_ID);
            }
        }
    }
    updateToggleButtonState(buttonId, isActive) {
        const buttonElement = document.getElementById(buttonId);
        if (buttonElement) {
            if (isActive) {
                buttonElement.classList.add('e-active');
            }
            else {
                buttonElement.classList.remove('e-active');
            }
        }
    }
    updateSplitButtonState(buttonId, isActive) {
        const element = document.getElementById(buttonId);
        if (!element) {
            return;
        }
        const splitButton = getInstance(element, SplitButton);
        if (!splitButton) {
            return;
        }
        const isCurrentlyActive = /\be-active\b/.test(splitButton.cssClass);
        if (isCurrentlyActive) {
            splitButton.cssClass = splitButton.cssClass.replace(/\be-active\b/, '').replace(/\s{2,}/g, ' ').trim();
        }
        if (isActive) {
            splitButton.cssClass = `${splitButton.cssClass} e-active`.trim();
        }
        splitButton.dataBind();
    }
    leftAlignmentAction() {
        if (!this.documentEditor.isReadOnly && this.documentEditor.selection) {
            this.documentEditor.selection.paragraphFormat.textAlignment = 'Left';
        }
    }
    centerAlignmentAction() {
        if (!this.documentEditor.isReadOnly && this.documentEditor.selection) {
            this.documentEditor.selection.paragraphFormat.textAlignment = 'Center';
        }
    }
    rightAlignmentAction() {
        if (!this.documentEditor.isReadOnly && this.documentEditor.selection) {
            this.documentEditor.selection.paragraphFormat.textAlignment = 'Right';
        }
    }
    justifyAction() {
        if (!this.documentEditor.isReadOnly && this.documentEditor.selection) {
            this.documentEditor.selection.paragraphFormat.textAlignment = 'Justify';
        }
    }
    increaseIndentAction() {
        if (!this.documentEditor.isReadOnly && this.documentEditor.editor) {
            this.documentEditor.editor.increaseIndent();
        }
    }
    decreaseIndentAction() {
        if (!this.documentEditor.isReadOnly && this.documentEditor.editor) {
            this.documentEditor.editor.decreaseIndent();
        }
    }
    toggleHiddenMarks() {
        if (this.documentEditor) {
            this.container.documentEditor.documentEditorSettings.showHiddenMarks = !this.container.documentEditor.documentEditorSettings.showHiddenMarks;
            setTimeout(() => {
                this.documentEditor.focusIn();
            }, 30);
        }
    }
    bordersAction() {
        if (!this.documentEditor.isReadOnly) {
            this.documentEditor.showDialog('BordersAndShading');
        }
    }
    /**
     * Clean up resources when group is destroyed
     * @returns {void}
     * @private
     */
    destroy() {
        if (this.bulletsGroup) {
            this.bulletsGroup.destroy();
            this.bulletsGroup = null;
        }
        if (this.numberingGroup) {
            this.numberingGroup.destroy();
            this.numberingGroup = null;
        }
        if (this.lineSpacingGroup) {
            this.lineSpacingGroup = null;
        }
    }
}
